import { createContext } from 'react';

export default createContext({
	subscriptionDetails: {},
	setSubscriptionDetails: () => { },
	isSubscriber: false
});
